import React, { Component } from 'react';
import { render } from 'react-dom';
import rehabPhases from "./rehabPhasesData";

//const rehabPhase = ({rehabPhase, duration}) => (
//    <div>
//        {rehabPhase} {duration}
//    </div>
//);

class RehabPhases extends Component {
    render () {
        return (
            <div>
                {rehabPhases.map((rehabPhases, index) => {
                    return <h4>{rehabPhases.rehabPhase1}</h4>
                })}
            </div>
        )
    }
}


export default RehabPhases;